export default __webpack_public_path__ + "locales/ko-KR/Webhooks.json?hash=3e65d165d1787132d6d66516d0dc2699";